import fetch from 'auth/FetchInterceptor';
import { API_BASE_URL } from 'configs/AppConfig';
import { checkPermission } from "utils/permissions";

const BASE_URL = API_BASE_URL;
let queryparam = { limit: Number.MAX_SAFE_INTEGER };

export function requestBrokerUsers(params) {
    return fetch.get(`${BASE_URL}/api/app/broker-user`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    })
}

export function requestBrokerUsersFilter(params) {
    if(!checkPermission("BROKER", "ADD_NON_IPC")){
        queryparam.firmType = "IPC";

      }
    //   queryparam.limit = params.limit;
    //   queryparam.pageNumber= params.pageNumber;
    return fetch.get(`${BASE_URL}/api/app/broker-user/getBrokerUserDetails?${params}`
    )
}

/**
 *
 * @param {BrokerUserForm} payload
 * @returns
 */
export function requestCreateBrokerUsers(payload) {
    return fetch.post(`${BASE_URL}/api/app/broker-user`, {
        ...payload,
        firmType: 2
    });
}

export function requestUpdateBrokerUsers(payload) {
    const data = { ...payload };
    delete data['_id'];
    return fetch.put(`${BASE_URL}/api/app/broker-user/${payload._id}`, data);
}

export function deleteBrokerUsers(firmData) {
    throw Error('Not implemented');
}
